module.exports = __webpack_public_path__ + "static/media/bella-lash.889c9cbe.jpg";